import { useParams, Link } from "react-router-dom";
import { categories, categoryVideos, featuredVideos } from "@/mocks/data";
import VideoCard from "@/components/base/VideoCard";
import Breadcrumb from "@/components/base/Breadcrumb";
import { useEffect, useState } from "react";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSort, setActiveSort] = useState("latest");

  const category = categories.find((c) => c.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug]);

  if (!category) {
    return (
      <main className="min-h-screen pt-24 px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto text-center py-20">
          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
            <i className="ri-emotion-sad-line text-3xl text-foreground-400"></i>
          </div>
          <h2 className="text-xl font-bold text-foreground-900 mb-2">分类未找到</h2>
          <p className="text-foreground-500 mb-6">请检查分类链接是否正确</p>
          <Link
            to="/"
            className="inline-flex px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </main>
    );
  }

  const videos = categoryVideos[category.slug] || featuredVideos.filter((v) => v.category === category.slug);
  const displayVideos = activeSort === "rating"
    ? [...videos].sort((a, b) => (b.rating || 0) - (a.rating || 0))
    : videos;

  return (
    <main className="min-h-screen pt-24 pb-14 px-4 md:px-6">
      <div className="max-w-[1200px] mx-auto">
        <div className="mb-6">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: category.name },
            ]}
          />
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: "var(--font-heading)" }}>
              {category.name}
            </h1>
            <p className="text-sm text-foreground-500 mt-1">{category.description}</p>
          </div>
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
            <button
              onClick={() => setActiveSort("latest")}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                activeSort === "latest"
                  ? "bg-background-50 text-foreground-900 shadow-sm"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              最新
            </button>
            <button
              onClick={() => setActiveSort("rating")}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                activeSort === "rating"
                  ? "bg-background-50 text-foreground-900 shadow-sm"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              评分最高
            </button>
          </div>
        </div>

        <div className="flex items-center gap-3 mb-6 overflow-x-auto pb-2 flex-wrap">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                cat.slug === slug
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </div>
              {cat.name}
            </Link>
          ))}
        </div>

        {displayVideos.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {displayVideos.map((video) => (
              <VideoCard key={video.id} {...video} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <p className="text-foreground-500">暂无内容，敬请期待</p>
          </div>
        )}
      </div>
    </main>
  );
}